<template>
  <div>
    <div class="fixed_page"  id="blurry">
      <div class="get-started popup_bg">
        <div class="stars-main">
          <div class="fixed_page">
            <div class="store_box">
              <div class="stars_content">
                <div class="stars_exchange_icons">
                  <div class="star_icon">  <img src="static/images/stars/stars.png" alt="" class=""></div>
                  <div class="arrow_icon">  <img src="static/images/stars/arrow_exchange.png" alt="" class=""></div>
                  <div class="points_icon">  <img src="static/images/stars/nojoom_logo.png" alt="" class=""></div>
                </div>
                <p>{{ getTranslations.home_stars_are_automatically }}</p>
                <h1>{{ getTranslations.home_exchange_your_stars }}</h1>
                <div class="profile_stars_container">
                  <div class="profile_stars_inside">
                    <div class="stars_icon"><img src="static/images/star.svg" alt="" class=""></div>
                    <div class="stars_count"><p>{{ userDetails.stars }}</p></div>
                  </div>
                  <div class="progressbar">
                    <p><span>{{ calculatePercentage + '%' }}</span></p>
                    <div class="progressbar__bar" :data-percent=calculatePercentage></div>
                  </div>
                </div>
              </div>
              <button type="" class="btn_stars_exchange" v-if="calculatePercentage >= 100" @click.prevent="openExchangeModal">{{ getTranslations.home_exchange_button }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <fade-transition>
      <component :is="currentModal" @close="currentModal = null" @openFailureModal="openFailureModal" @openSuccessModal="openSuccessModal"></component>
    </fade-transition>
  </div>
</template>

<script>
  /* eslint no-console: "off", no-param-reassign: ["error", { "props": false }], no-use-before-define: ["error", { "variables": false }] */
import { mapGetters, mapState } from 'vuex';
import FadeTransition from '@/components/home/sharedcomponents/FadeTransition';
import RoundUpMixin from '@/common/mixins/roundUp';
import modals from '@/common/modals';
import $ from 'jquery';
import ExchangeStarsModal from './modals/stars/ExchangeStarsModal';
import SuccessfulExchange from './modals/stars/SuccessfulExchange';
import FailedExchange from './modals/stars/FailedExchange';

export default {
  name: 'exchangeStars',
  components: { FailedExchange, SuccessfulExchange, FadeTransition },
  mixins: [RoundUpMixin],
  data() {
    return {
      currentModal: null,
    };
  },
  mounted() {
    this.updateBar();
  },
  methods: {
    updateBar() {
      /* eslint-disable */
      $(".progressbar__bar").each(function (t, e) {
        var n = $(e).data("percent");
        $(e).width(n + "%")
      })
      /* eslint-enable */
    },
    openExchangeModal() {
      this.currentModal = ExchangeStarsModal;
      modals.showHideModalGeneric(this);
    },
    openFailureModal() {
      this.currentModal = FailedExchange;
      modals.showHideModalGeneric(this);
    },
    openSuccessModal() {
      this.currentModal = SuccessfulExchange;
      modals.showHideModalGeneric(this);
    },
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    ...mapState('common', [
      'userDetails',
      'exchangeStarsPoints',
    ]),
    calculatePercentage() {
      if (this.userDetails.stars === 0) return 0;
      const percentage = this.roundUpNumber((Math.floor((this.userDetails.stars / this.exchangeStarsPoints) * 100)));
      return percentage >= 100 ? 100 : percentage;
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/home/ExchangeStars.vue